import { useEffect, useState, useMemo } from 'react';
import { Brand, Country, getBrands, getCountries } from 'api';

// Custom hook for handling brands and countries
export const useBrandsAndCountries = () => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);
  const [activeBrand, setActiveBrand] = useState<Brand>();
  const [activeCountry, setActiveCountry] = useState<Country>();

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const fetchedBrands = await getBrands();
        setBrands(fetchedBrands);
        if (fetchedBrands.length > 0) {
          setActiveBrand(fetchedBrands[0]);
        }
      } catch (error) {
        console.error('Failed to fetch brands:', error);
      }
    };
    
    fetchBrands();
  }, []);

  useEffect(() => {
    const fetchCountries = async () => {
      if (!activeBrand) return;
      
      try {
        const results = await getCountries();
        const filteredCountries = results.filter(({ brandId }) => activeBrand.id === brandId);
        setCountries(filteredCountries);
        
        if (filteredCountries.length > 0) {
          setActiveCountry(filteredCountries[0]);
        }
      } catch (error) {
        console.error('Failed to fetch countries:', error);
      }
    };
    
    fetchCountries();
  }, [activeBrand]);

  return useMemo(() => ({
    brands,
    countries,
    setCountries,
    activeBrand,
    setActiveBrand,
    activeCountry,
    setActiveCountry
  }), [brands, countries, activeBrand, activeCountry]);
};
